import React, { useEffect, useState, useRef } from "react";
import { errorMsg, successMsg } from "../Toastify";
import {
  CreateCompOffLeave,
  EmployeeProfile,
  GetEmployeeCompOffLeaveList,
} from "../../Repository/Api";
import { useSelector } from "react-redux";
import moment from "moment";
import { useParams } from "react-router-dom";
import CustomModal from "../CustomModal";
import { NonEmptyValidation } from "../../Store/validate";
import MUIDataTable from "mui-datatables";
import { DateRangePicker } from "react-date-range";
import { enUS } from 'date-fns/locale';
const Staffcompoff = () => {
  const { first_name, desingation, department, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token
  const { id } = useParams();

  const [leaveList, setLeaveList] = useState([]);
  const [compLeaveModel, setCompLeaveModel] = useState(false);
  const [createCompLeave, setCreateCompLeave] = useState([]);
  const [validation, setValidation] = useState({});
  const [dateFilterOpen, setDateFilterOpen] = useState(false)
  const filterIntialState = [
    {
      startDate: null,
      endDate: new Date('2030-01-01'),
      key: "selection",
    },
  ]
  const dfm = (date) => {
    return moment(date).format("DD/MM/yyyy")
  }
  const [range, setRange] = useState(filterIntialState);
  // console.log(range[0].startDate, "date range")
  const handleSelect = (ranges) => {
    setRange([ranges.selection]);
  };

  const dateFilterRef = useRef(null);
  const handleClickOutside = (event) => {
    if (dateFilterRef.current && !dateFilterRef.current.contains(event.target)) {
      setDateFilterOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    getLeaveList();
  }, [range]);

  const [active, setActive] = useState(0);
  const links = ["Pending", "Approved", "Rejected"];
  const showSelected = (index) => {
    setActive(index);
  };

  const setData = (e, key) => {
    let TempData = createCompLeave;
    TempData[key] = e;
    setCreateCompLeave(TempData);
    if (validation[key]) setValidation({ ...validation, [key]: false });
  };

  const setValidationValue = (key, value) => {
    setValidation({ ...validation, [key]: value });
  };

  const getLeaveList = async () => {
    const response = await GetEmployeeCompOffLeaveList(token);
    if (response && response.statusCode === 200) {
      setLeaveList(response?.data?.comp_off_details.filter(item => {
        const startDate = new Date(item.date);
        const rangeStartDate = new Date(range[0].startDate)
        const rangeEndDate = new Date(range[0].endDate)
        startDate.setHours(0, 0, 0, 0);
        rangeStartDate.setHours(0, 0, 0, 0);
        rangeEndDate.setHours(0, 0, 0, 0);
        return (startDate >= rangeStartDate && startDate <= rangeEndDate);
      }));
    } else {
      errorMsg(response.message);
    }
  };

  const pendingLeaveLength = leaveList.filter(
    (item) => item.status === "pending"
  ).length;
  const approveLeaveLength = leaveList.filter(
    (item) => item.status === "approved"
  ).length;
  const rejectLeaveLength = leaveList.filter(
    (item) => item.status === "rejected"
  ).length;

  const handleSubmit = async (e) => {
    e.preventDefault();

    let validate = {};
    validate.date = NonEmptyValidation(createCompLeave?.date);
    validate.description = NonEmptyValidation(createCompLeave?.description);
    setValidation(validate);

    if (Object.values(validate).every((v) => v.status === true)) {
      const Payload = {
        id: id,
        date: createCompLeave.date,
        description: createCompLeave.description,
      };

      const response = await CreateCompOffLeave(Payload, token);
      if (response && response.statusCode === 200) {
        successMsg(response.message);
        setCreateCompLeave({});
        e.target.reset();
        setCompLeaveModel(false);
        getLeaveList();
      } else {
        errorMsg(response.message);
      }
    }
  };

  const pendingLeave = leaveList?.filter((leaveList) => leaveList.status === "pending")
  const approvedLeave = leaveList?.filter((leaveList) => leaveList.status === "approved")
  const rejectedLeave = leaveList?.filter((leaveList) => leaveList.status === "rejected")

  let compoffLeave

  if (active === 0) {
    compoffLeave = pendingLeave
  } else if (active === 1) {
    compoffLeave = approvedLeave
  } else if (active === 2) {
    compoffLeave = rejectedLeave
  }


  const options = {
    filterType: "checkbox",
    selectableRows: "none",
    viewColumns: false,
  };

  const columns = [
    {
      name: "date",
      label: "Worked Date",
      options: {
        customBodyRender: (value, tableMeta) => {
          return moment(value).format("DD MMM YY");
        },
      },
    },
    {
      name: "expiry_date",
      label: "Expired Date",
      options: {
        customBodyRender: (value, tableMeta) => {
          return moment(value).format("DD MMM YY");
        },
      },
    },
    {
      name: "hod_status",
      label: "Hod Status",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <div
              className={
                value === "approved"
                  ? "till-active"
                  : "not-active-wait" &&
                    value === "rejected"
                    ? "not-active"
                    : "not-active-wait"
              }
            >
              {value ?? "-"}
            </div >
          );
        },
      },
    },
    {
      name: "admin_status",
      label: "Admin Status",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <div className={value === "forwarded" ? "till-active" : "not-active-wait"}>
              {value ?? "-"}
            </div>
          );
        },
      },
    },
    {
      name: "director_status",
      label: "Director Status",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <div
              className={value === "approved" ? "till-active" : "not-active-wait" &&
                value === "rejected" ? "not-active" : "not-active-wait"}>
              {value ?? "-"}
            </div>
          );
        },
      },
    },
    {
      name: "description",
      label: "Description",
    }
  ];

  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6 p-0">
                <h6 className="headertext">
                  {first_name} - {desingation}
                </h6>
                <h6 className="subheadertext">{department}</h6>
              </div>
              <div className="col-lg-6">
                <div className="headeralign">
                  <button
                    className="requestbtn"
                    onClick={() => {
                      setCompLeaveModel(true);
                    }}
                  >
                    Apply Comp Off
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="">
              <div className="graphbox">
                <div className="row">
                  <div className="col-lg-3 p-0">
                    <h6 className="labeltitle">Comp Off Request Status</h6>
                  </div>
                  <div className="col-lg-4 p-0">
                    <ul className="searchtopflex">
                      {links.map((link, index) => {
                        return (
                          <li
                            onClick={() => { showSelected(index); setRange(filterIntialState) }}
                            key={link}
                            className={
                              active === index
                                ? "agenttextactive"
                                : "agenttextinactive"
                            }
                          >
                            {link}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
                <div className="mt-3 d-flex align-items-center justify-content-end">
                  <div className="w-25 leave-filter-input" ref={dateFilterRef}>
                    <input
                      className="form-control"
                      defaultValue={range[0].startDate ? ((range[0].startDate.getTime() == range[0].endDate.getTime()) ? dfm(range[0].endDate) : dfm(range[0].startDate) + " - " + dfm(range[0].endDate)) : null}
                    />
                    <span
                      className="material-symbols-outlined leave-filter-calendar"
                      onClick={() => setDateFilterOpen(true)}
                    >
                      calendar_month
                    </span>
                    {dateFilterOpen && (
                      <DateRangePicker
                        ranges={range}
                        onChange={handleSelect}
                        locale={enUS}
                      />
                    )}
                  </div>
                  {range[0].startDate &&
                    <div>
                      <span
                        class="material-symbols-outlined ms-3 filter-reset-button"
                        onClick={() => setRange(filterIntialState)}
                      >
                        cancel
                      </span>
                    </div>}
                </div>
                < MUIDataTable
                  data={compoffLeave}
                  columns={columns}
                  options={options}
                  className="mt-3"
                />
              </div>
            </div>
          </div>
        </section>

        {/*  ApproveModal */}
        <CustomModal
          open={compLeaveModel}
          onClickOutside={() => {
            setCompLeaveModel(false);
            setCreateCompLeave({});
            setValidation({});
          }}
        >
          <form onSubmit={(e) => handleSubmit(e)}>
            <div className="modal-content Modal-View m-auto">
              <div className="modalHeader text-center py-2">
                <h5 className="font-bold mt-2">Apply Comp Off Leave</h5>
              </div>
              <div className="modal-body p-0 ">
                <div className="container">
                  <div className="row d-flex align-items-center justify-content-center  mt-0">
                    <div className="container ">
                      <div className="row justify-content-center">
                        <div className="col-lg-8">
                          <div className=" my-5 px-3">
                            <div className="row justify-content-center mt-2">
                              <div className="col-lg-10">
                                <div className="mb-3">
                                  <div>
                                    <label className="labeltext">Date:</label>
                                    <input
                                      type="date"
                                      className="fieldinput"
                                      placeholder="Enter Comment"
                                      defaultValue={createCompLeave.date}
                                      max={moment(createCompLeave?.date).format(
                                        "YYYY-MM-DD"
                                      )}
                                      onChange={(e) => {
                                        setData(e.target.value, "date");
                                      }}
                                      onBlur={(e) => {
                                        setValidationValue(
                                          "date",
                                          NonEmptyValidation(e.target.value)
                                        );
                                      }}
                                    />
                                  </div>
                                  <small className="validationerror">
                                    {validation?.date?.message
                                      ? `Date ${validation?.date?.message}`
                                      : ""}
                                  </small>
                                </div>
                                <div className="mb-3">
                                  <div>
                                    <label className="labeltext">
                                      Description:
                                    </label>
                                    <textarea
                                      type="text"
                                      className="fieldinput"
                                      placeholder="Enter Comment"
                                      defaultValue={createCompLeave.description}
                                      onChange={(e) => {
                                        setData(e.target.value, "description");
                                      }}
                                      onBlur={(e) => {
                                        setValidationValue(
                                          "description",
                                          NonEmptyValidation(e.target.value)
                                        );
                                      }}
                                    />
                                  </div>
                                  <small className="validationerror">
                                    {validation?.description?.message
                                      ? `Description ${validation?.description?.message}`
                                      : ""}
                                  </small>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer border-0">
                <div className="my-3">
                  <button
                    type="button"
                    className="btn mx-2 modelclosebtn"
                    onClick={() => {
                      setCompLeaveModel(false);
                      setValidation({});
                      setCreateCompLeave({});
                    }}
                  >
                    Back
                  </button>
                </div>
                <div>
                  <button className="btn mx-2 modelsubmitbtn">Save</button>
                </div>
              </div>
            </div>
          </form>
        </CustomModal>
      </div>
    </>
  );
};

export default Staffcompoff;
